export default __webpack_public_path__ + "static/media/035-information-1.89a3ae7e.svg";